import apiClient from './apiConfig';

export const usersApi = {
  // Get user by ID
  getUserById: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update user profile
  updateUser: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Change user password
  changePassword: async (userId, passwordData) => {
    try {
      const response = await apiClient.put(`/users/${userId}/password`, passwordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update user profile picture
  updateProfilePicture: async (userId, profilePic) => {
    try {
      const response = await apiClient.put(`/users/${userId}/profile-pic`, {
        profilePic
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete user account
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get user statistics
  getUserStats: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}/stats`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
